import React from 'react';
import { MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';
import UnitListCard from './ComponentFragments/UnitListCard';


export default class UnitList extends React.Component {

    constructor(props) {
        super();
        this.state = {
            unitData: [],
            filteredData: [],
            isModalVisible: false,
            sfId: 0,
            unitId: 0
        }

        this.searchList = this.searchList.bind(this);
        this.formatter = new Formatter();
    }

    searchList(phrase) {
        let arr = this.state.unitData.filter((dem) => (dem.managerName.toUpperCase().includes(phrase.toUpperCase())) || (dem.unitName.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({ filteredData: arr });
    }

    async componentWillMount(nextProps) {
        this.props.loaderOn();
        var dl = new DataLayer();

        await dl.Get('/teamleader/getunitslist', 200).then((response) => {
            this.setState({
                unitData: response.data.data,
                filteredData: response.data.data,
            });
            this.props.loaderOff();
        })

    }

    
   render() {
        return (
            <div>
                <Header headerText="Unit List"
                    placeholderText="Search Unit/Manager Name"
                    searchList={this.searchList}
                />
                
                <MDBRow>
                    {
                        this.state.filteredData.map((unit) => {
                            return (
                                <MDBCol xl="4" lg="6" md="6" sm="12" className="mb-r" >
                                    <UnitListCard {...this.props}
                                        unitName={unit.unitName}
                                        managerName={unit.managerName}
                                        telephoneCell={unit.telephoneCell}
                                        sales={unit.sales}
                                        prevSegmentSales={unit.prevSegmentSales}
                                        sfId={unit.sfId}
                                        unitId={unit.unitId}
                                        unitName={unit.unitName}
                                        isPromoteoutList={false}
                                    />
                                    {/*
                                    <UnitListCard
                                        unitName={unit.unitName}
                                        managerName={unit.managerName}
                                        telephoneCell={unit.telephoneCell}
                                        sales={unit.sales}
                                        prevSegmentSales={unit.prevSegmentSales}
                                        sfId={unit.sfId}
                                        unitId={unit.unitId}
                                        unitName={unit.unitName}
                                        loaderOff={this.props.loaderOff}
                                        loaderOn={this.props.loaderOn}
                                    />
                                    */}
                                    </MDBCol>

                                
                            );
                        })
                    }
                </MDBRow>
            </div>
        );
    }
}